import React from 'react'
import PropTypes from 'prop-types'
import { Switch as AntdSwitch } from 'antd'

export const Switch = ({ label, ...rest }) => {
  if (!label) return <AntdSwitch {...rest} />

  return (
    <label>
      <AntdSwitch {...rest} />
      <span style={{ marginLeft: '.5em' }}>{label}</span>
    </label>
  )
}

Switch.propTypes = {
  label: PropTypes.string,
}

Switch.defaultProps = {
  label: '',
}
